module.exports = __webpack_public_path__ + "static/media/6980.828956bd.jpg";